import {
  bindGoogleAuthenticator,
  checkBindGoogleAuthenticator,
  getUserInfo,
} from "@/apis/user";
import { useUserInfoStore } from "@/stores/userInfo";
import { Toast } from "antd-mobile";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const useBindSetup = () => {
  const navigate = useNavigate();
  const userStore = useUserInfoStore()();
  const [googleCode, setGoogleCode] = useState<{
    secret: string;
    qrCodeUrl: string;
  }>({
    secret: "",
    qrCodeUrl: "",
  });
  const fetchBindGoogleAuthenticator = async (securePassword: string) => {
    const { ok, data, msg } = await bindGoogleAuthenticator({ securePassword });
    if (ok) {
      Toast.show(msg);
      setGoogleCode(data);
    } else {
      Toast.show(msg);
      navigate(-1);
    }
  };

  const fetchCheckBindGoogleAuthenticator = async (values: {
    safeCode: string;
    secret: string;
  }) => {
    //     if (this.password.length !== 6) return this.$toast.fail("请输入google验证码")
    const { ok, msg } = await checkBindGoogleAuthenticator({
      safeCode: values.safeCode,
      secret: values.secret,
    });
    if (ok) {
      Toast.show(msg);
      const response = await getUserInfo({});
      if (response.ok) {
        if (response.data) {
          userStore.setUserInfo(response.data);
        }
        navigate(-1);
      } else {
        Toast.show(msg);
      }
    }
  };
  return {
    googleCode,
    fetchBindGoogleAuthenticator,
    fetchCheckBindGoogleAuthenticator,
  };
};

export { };

// methods: {
//   async bindGoogleAuthenticator(securePassword) {
//     const {ok, data, msg} = await bindGoogleAuthenticator({securePassword})
//     if (ok) {
//       this.authInfo = {...(data || {})}
//       this.$toast.success(msg);
//     } else {
//       this.$toast.fail(msg)
//       this.$router.back()
//     }
//   },
//   async checkBindGoogleAuthenticator() {
//     if (this.password.length !== 6) return this.$toast.fail("请输入google验证码")
//     const {ok, msg} = await checkBindGoogleAuthenticator({
//       safeCode: this.password,
//       secret: this.authInfo.secret,
//     })
//     if (ok) {
//       this.$toast.success(msg);
//       await this.$root.fetchUserInfo()
//       this.$router.back()
//     } else {
//       this.$toast.fail(msg)
//     }
//   }
// },
// beforeRouteEnter(to, from, next) {
//   next(vm => {
//     vm.$dialog({
//       className: "common",
//       title: "请输入资金密码",
//       message: "为了您的账户安全，绑定谷歌验证器需要验证资金密码",
//       confirmButtonText: "确认",
//       beforeClose: async (action, done) => {
//         done()
//         const val = await verifySecuretedCode(vm)
//         if (val && val.length === 6) {
//           vm.$root.$emit("root:set-topbar", ["left-back"]);
//           await vm.bindGoogleAuthenticator(val)
//         } else {
//           if(val === 'close-by-route-change') return
//           setTimeout(() => vm.$router.back(), 350)
//         }
//       }
//     })
//   })
// }
